// extracted by mini-css-extract-plugin
export default {"container":"v2brxboF0vBFQ_FuojAE"};